import { loadDraft, saveDraft, STORAGE_KEY, type Snapshot, type StorageLike } from './model.ts';
export const RECOVERY_INDEX = `${STORAGE_KEY}_quiz_recovery`;
export type RecoveryEntry = { key: string; savedAt: string; recipient: string; pieces: number };
export function recoveryEntries(storage: StorageLike | null): RecoveryEntry[] {
  if (!storage) return [];
  try {
    const entries = JSON.parse(storage.getItem(RECOVERY_INDEX) ?? '[]');
    if (!Array.isArray(entries) || entries.some(e=> !e || typeof e.key!=='string' || !e.key.startsWith(`${RECOVERY_INDEX}:`) || typeof e.savedAt!=='string' || !Number.isSafeInteger(e.pieces))) throw new Error();
    return entries;
  } catch { throw new Error('Previous designs could not be read. Your current draft was kept.'); }
}
// Caller holds the same existing designer lock for the complete archive + revision-checked save.
export function preserveAndApply(storage: StorageLike | null, snapshot: Snapshot, revision: number, writer: string, inline: ReadonlySet<string>, attachments: ReadonlySet<string>, archiveId: string) {
  if (!storage) throw new Error('Browser saving is unavailable. Your design was not changed.');
  const current = loadDraft(storage,inline,attachments);
  if (current.status==='invalid' || current.status==='unavailable') throw new Error(current.message);
  if (current.revision!==revision) throw new Error('Another window changed your draft. Review it before trying again.');
  if (current.status==='loaded') {
    const entries = recoveryEntries(storage);
    const key = `${RECOVERY_INDEX}:${archiveId}`;
    if (storage.getItem(key)!==null) throw new Error('Recovery identity already exists. Please retry.');
    const raw = storage.getItem(STORAGE_KEY);
    if (!raw) throw new Error('Your saved draft changed. Please retry.');
    try {
      storage.setItem(key,raw);
      storage.setItem(RECOVERY_INDEX,JSON.stringify([...entries,{key,savedAt:new Date().toISOString(),recipient:current.snapshot.design.recipient_mode,pieces:current.snapshot.design.inline_items.length+current.snapshot.design.attachments.length}]));
    } catch { throw new Error('There is not enough browser storage to preserve your original design. Nothing was replaced.'); }
  }
  const result = saveDraft(storage,snapshot,revision,writer,inline,attachments);
  if (!result.ok) throw new Error(result.message);
  return result;
}
